import { defaultControlErrors } from '$core/models/errors';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-custom-control-error',
  templateUrl: './custom-control-error.component.html',
  styleUrls: ['./custom-control-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomControlErrorComponent {
  @Input() public set setErrors(errors: Array<string> | Object) {
    this.dataType = Array.isArray(errors) ? 'array' : 'object';
    this.errors$.next(errors);
  }
  public readonly defaultControlErrors = defaultControlErrors;
  public readonly errors$: BehaviorSubject<Array<string> | Object> =
    new BehaviorSubject<Array<string> | Object>(null);
  public dataType: 'array' | 'object';
}
